module.exports = __webpack_public_path__ + "img/over-tip@2x.c7b35dbe.png";